import { createCountryFlag,getFlaggedPorts,createPortsFlag,getFlaggedCountries, updatePortFlag as editPortFlag,updateCountryFlag as editCountryFlag  } from '../utils/apiService';

export const CREATE_COUNTRY_FLAG = 'flag/CREATE_COUNTRY_FLAG';
export const CREATE_COUNTRY_FLAG_PENDING = 'flag/CREATE_COUNTRY_FLAG_PENDING';
export const CREATE_COUNTRY_FLAG_FULFILLED = 'flag/CREATE_COUNTRY_FLAG_FULFILLED';
export const CREATE_COUNTRY_FLAG_REJECTED = 'flag/CREATE_COUNTRY_FLAG_REJECTED';

export const CREATE_PORTS_FLAG="flag/CREATE_PORTS_FLAG";
export const CREATE_PORTS_FLAG_PENDING="flag/CREATE_PORTS_FLAG_PENDING";
export const CREATE_PORTS_FLAG_FULFILLED="flag/CREATE_PORTS_FLAG_FULFILLED";
export const CREATE_PORTS_FLAG_REJECTED="flag/CREATE_PORTS_FLAG_REJECTED";


export const LIST_COUNTRY_FLAGS = 'flag/LIST_COUNTRY_FLAGS';
export const LIST_COUNTRY_FLAGS_PENDING = 'flag/LIST_COUNTRY_FLAGS_PENDING';
export const LIST_COUNTRY_FLAGS_REJECTED = 'flag/LIST_COUNTRY_FLAGS_REJECTED';
export const LIST_COUNTRY_FLAGS_FULFILLED = 'flag/LIST_COUNTRY_FLAGS_FULFILLED';

export const LIST_PORT_FLAGS = 'flag/LIST_PORT_FLAGS';
export const LIST_PORT_FLAGS_PENDING = 'flag/LIST_PORT_FLAGS_PENDING';
export const LIST_PORT_FLAGS_REJECTED = 'flag/LIST_PORT_FLAGS_REJECTED';
export const LIST_PORT_FLAGS_FULFILLED = 'flag/LIST_PORT_FLAGS_FULFILLED';

export const UPDATE_COUNTRY_FLAG = 'flag/UPDATE_COUNTRY_FLAG';
export const UPDATE_COUNTRY_FLAG_PENDING = 'flag/UPDATE_COUNTRY_FLAG_PENDING';
export const UPDATE_COUNTRY_FLAG_FULFILLED = 'flag/UPDATE_COUNTRY_FLAG_FULFILLED';
export const UPDATE_COUNTRY_FLAG_REJECTED = 'flag/UPDATE_COUNTRY_FLAG_REJECTED';

export const UPDATE_PORT_FLAG='flag/UPDATE_PORT_FLAG';
export const UPDATE_PORT_FLAG_PENDING='flag/UPDATE_PORT_FLAG_PENDING';
export const UPDATE_PORT_FLAG_FULFILLED='flag/UPDATE_PORT_FLAG_FULFILLED';
export const UPDATE_PORT_FLAG_REJECTED='flag/UPDATE_PORT_FLAG_REJECTED';


export const saveCountryFlag= (countryFlag) => {
    const payload = createCountryFlag(countryFlag);
    return {
        type: CREATE_COUNTRY_FLAG,
        payload
    }
}
export const savePortsFlag=(portsFlag)=>{
    const payload=createPortsFlag(portsFlag);
    return{
        type: CREATE_PORTS_FLAG,
        payload
    }
}

export const updateCountryFlag = (countryFlag) => {
    const payload = editCountryFlag(countryFlag);
    return {
        type: UPDATE_COUNTRY_FLAG,
        payload
    }
}
export const updatePortFlag=(portFlag)=>{
    const payload=editPortFlag(portFlag);
    return {
        type:UPDATE_PORT_FLAG,
        payload
    }
}

export const listCountryFlags = () => {
    const payload = getFlaggedCountries();
    return {
        type: LIST_COUNTRY_FLAGS,
        payload
    }
}

export const listPortFlags=()=>{
    const payload=getFlaggedPorts();
    return {
        type:LIST_PORT_FLAGS,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/flagged.js